/* eslint-disable @typescript-eslint/no-magic-numbers */
import { Vector3 } from "three";
import { FluxSvgLoader } from "./fluxSvgLoader";
export function getPathsFromSvgString(svgString) {
    const loader = new FluxSvgLoader();
    const svgData = loader.parse(svgString);
    return svgData.paths;
}
export function createShapesFromPath(path) {
    return FluxSvgLoader.createShapes(path);
}
export function pointsToStroke(subPath, scale, path, extrudeSettings) {
    return FluxSvgLoader.pointsToStroke(subPath.getPoints(64).map((vector) => new Vector3(vector.x * scale, -vector.y * scale, 1)), path.userData?.style, 12, 
    // This precision was chosen based on how #1 pin silk dots are
    // commonly represented (a small stroked circle) and dividing it up
    // into 128 segments for smoothness.
    0.0000001, true, extrudeSettings);
}
//# sourceMappingURL=fluxSvgHelpers.js.map